import React from "react";
import { Link as RouterLink } from "react-router-dom";

function serviceAnchor(unikey) {
  return unikey ? String(unikey).split('-')[0] : '';
}

function plainText(value) {
  if (value == null || typeof value === 'object') return value;
  return String(value).replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
}

function padIndex(index) {
  return String((index || 0) + 1).padStart(2, '0');
}

export default function ServiceArea(props) {
  const { title, description, image, linkKey, index = 0 } = props;
  const isSkeleton = typeof image === 'object' || typeof title === 'object';
  const text = plainText(description);
  const href = `/dienstleistungen#${serviceAnchor(linkKey)}`;

  const media = isSkeleton ? (
    <div className="spg-service-card-media is-skeleton">{image}</div>
  ) : image ? (
    <div className="spg-service-card-media">
      <img src={image} alt="" />
    </div>
  ) : (
    <div className="spg-service-card-media is-empty" />
  );

  const body = (
    <div className="spg-service-card-body">
      <span className="spg-service-index">{padIndex(index)}</span>
      <h3>{title}</h3>
      {text ? <p>{text}</p> : null}
      {!isSkeleton && <span className="spg-service-more">Mehr erfahren</span>}
    </div>
  );

  if (isSkeleton || !linkKey) {
    return (
      <article className="spg-service-card is-static">
        {media}
        {body}
      </article>
    );
  }

  return (
    <RouterLink className="spg-service-card" to={href}>
      {media}
      {body}
    </RouterLink>
  );
}

export function ServiceExtendedArea(props) {
  const { title, description, text, image, index = 0, unikey } = props;
  const html = text || '';
  const lead = !html ? plainText(description) : '';
  const reversed = index % 2 === 1;

  return (
    <article
      id={serviceAnchor(unikey)}
      className={`spg-service-row${reversed ? ' is-reversed' : ''}`}
    >
      <div className={`spg-service-visual${image ? '' : ' is-empty'}`}>
        {image && typeof image !== 'object' ? (
          <img src={image} alt={typeof title === 'string' ? title : ''} />
        ) : image && typeof image === 'object' ? (
          image
        ) : null}
      </div>
      <div className="spg-service-copy">
        <span className="spg-service-index">{padIndex(index)}</span>
        <h3>{title}</h3>
        {lead ? <p className="spg-service-lead">{lead}</p> : null}
        {html ? (
          <div className="spg-service-text" dangerouslySetInnerHTML={{ __html: html }} />
        ) : null}
        <RouterLink className="spg-btn" to="/online-termin">
          Termin anfragen
        </RouterLink>
      </div>
    </article>
  );
}
